import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterOpcoesFiltro() {
        return axiosJwt
            .get(`${api}/sgtec/gestores/relatorios/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorio(filtro) {
        let url = `${api}/sgtec/gestores/relatorios/geral?unidade=${filtro.unidade ? filtro.unidade : ''
            }&dataInicioDe=${filtro.dataInicioDe ? filtro.dataInicioDe : ''
            }&dataInicioAte=${filtro.dataInicioAte ? filtro.dataInicioAte : ''
            }&dataTerminoDe=${filtro.dataTerminoDe ? filtro.dataTerminoDe : ''
            }&dataTerminoAte=${filtro.dataTerminoAte ? filtro.dataTerminoAte : ''
            }&statuscomprometimento=${filtro.statusComprometimento
            }&status=${filtro.status != undefined ? filtro.status : ''}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
